import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CreateloadService } from '../../../services/createload.service';
import { CustomersService } from '../../../services/customers.service';
import { DispatcherService } from '../../../services/dispatcher.service';
import { InvoiceService } from '../../../services/invoice.service';
import { TrucksService } from '../../../services/trucks.service';
import { AuthenticationService } from '../../authentication.service';
import { ToastrService } from "ngx-toastr";
import { map, startWith } from "rxjs/operators";

import * as moment from "moment";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
@Component({
  selector: 'app-invoicelist',
  templateUrl: './invoicelist.component.html',
  styleUrls: ['./invoicelist.component.scss'],
  providers: [ToastrService, CreateloadService, CustomersService, TrucksService, DispatcherService, InvoiceService]
})
export class InvoicelistComponent implements OnInit {

  constructor(private _toaster: ToastrService,
    private _loadservice: CreateloadService,
    private _invoiceservice: InvoiceService,
    private authService: AuthenticationService,
    private _customersservice: CustomersService,
    private _trucksservice: TrucksService,
    private _dispatcherService: DispatcherService,
    private router: Router,
    private formBuilder: UntypedFormBuilder,
  ) {(window as any).pdfMake.vfs = pdfFonts.pdfMake.vfs; }

  loadstatusDetails: any = [];
  selectedRows
  ngOnInit() {
    this.loadstatusDetails = this._loadservice.getLoadStatusList("Invoice");
    this.searchFormBuild();
    this.getCustomerdata();
    this.getTrucks();
    this.getDispatcherData();
    this.getInvoiceList();

  }
  InvoiceList = [];
  getInvoiceList() {
    this._invoiceservice.getInvoiceList().subscribe(
      (data) => {
        if (data.result != undefined) {
          this.InvoiceList = data.result;
          console.log(this.InvoiceList);
          this.getInvoiceLineItems();
        }
      });
  }

  searchForm: UntypedFormGroup;
  searchFormBuild() {
    this.searchForm = this.formBuilder.group({
      customer: [''],
      customerId: [''],
      loadNumber: [''],
      // truck: [''],
      dispatcher: [''],
      fromDate: [''],
      toDate: [''],
      loadStatus: [''],
      invoiceId: [''],
      invoiceStatus: [''],
    }, {});

  }

  onInvoiceSearch() {
    console.log(this.searchForm.value);
    console.log(JSON.stringify(this.searchForm.value));
    //  this.getData(this.searchForm.value);

  }
  onInvoiceReset() {
    this.searchFormBuild();
    console.log(this.searchForm.value);
    //this.getData(this.searchForm.value);
  }
  onManageInvoiceClick() {
    this.router.navigateByUrl("/sales/invoice");
  }
  customerdata = [];
  filteredCustomers;
  customerNameIdMap = {};
  getCustomerdata() {
    this.customerdata = [];
    this._customersservice.getCustomersData().subscribe((data) => {
      for (var i = 0; i < data.result.length; i++) {
        if (data.result[i].name != undefined) {
          this.customerdata.push(data.result[i]);
          console.log(this.customerdata);
          this.customerNameIdMap[data.result[i].name] = data.result[i]._id;
          console.log(this.customerNameIdMap);
        }
      }
    });
    this.filteredCustomers = this.searchForm.get("customer")!.valueChanges.pipe(
      startWith(""),
      map((value) => this._filter(value))
    );
  }
  private _filter(value: string): string[] {
    if (value != "" || value != undefined) {
      const filterValue = value.toLowerCase();
      return this.customerdata.filter((option) =>
        option.name.toLowerCase().includes(filterValue)
      );
    } else {
      return this.customerdata;
    }
  }

  isCustomerSelected = false;
  onCustomerSelected(customerName) {
    if (customerName != "") {
      this.searchForm.get("customerId").setValue(this.customerNameIdMap[customerName]);
      this.isCustomerSelected = true;
      console.log(this.searchForm.value);
    }
  }
  truckData = [];
  getTrucks() {
    this._trucksservice.getTrucksData().subscribe((data) => {
      console.log("Truck Data");
      console.log(data.result);
      this.truckData = data.result;
    });
  }
  dispatcherdata = [];
  getDispatcherData() {
    this._dispatcherService.getDispatcherData().subscribe((data) => {
      this.dispatcherdata = data.result || [];
    });
  }
  InvoiceLineItems = [];
  getInvoiceLineItems() {
    this._invoiceservice.getInvoiceLineItemsforLoad().subscribe(
      (data) => {
        if (data.result != undefined) {
          this.InvoiceLineItems = data.result;
          console.log(this.InvoiceLineItems);
        }
      });
  }
  downloadInvoice(selectedInvoice) {
    console.log(selectedInvoice);
    let invoice = this.InvoiceList.filter(
      (x) =>
        x.invoiceId === selectedInvoice
    )[0];
    let invoiceInfo = {};
    invoiceInfo["invoiceId"] = invoice.invoiceId;
    invoiceInfo["companyName"] = invoice.companyName;
    invoiceInfo["companyAddress"] = invoice.companyAddress;
    invoiceInfo["invoiceAmount"] = invoice.invoiceAmount;
    invoiceInfo["createdAt"] = invoice.createdAt;
    invoiceInfo["customerName"] = invoice.customerName;
    invoiceInfo["CustomerAddress"] = "-";


    let invoiceLineItems = this.InvoiceLineItems.filter(
      (x) =>
        x.invoiceId.invoiceId === selectedInvoice
    );
    let invoiceItemsData: any[][] = [
      [
        {
          text: 'Load #',
          fillColor: '#eaf2f5',
          border: [false, true, false, true],
          margin: [0, 5, 0, 5],
          textTransform: 'uppercase',
        },
        {
          text: 'Customer Ref',
          fillColor: '#eaf2f5',
          border: [false, true, false, true],
          margin: [0, 5, 0, 5],
          textTransform: 'uppercase',
        },
        {
          text: 'Shipper Ref',
          fillColor: '#eaf2f5',
          border: [false, true, false, true],
          margin: [0, 5, 0, 5],
          textTransform: 'uppercase',
        },
        {
          text: 'Description',
          fillColor: '#eaf2f5',
          border: [false, true, false, true],
          margin: [0, 5, 0, 5],
          textTransform: 'uppercase',
        },
        {
          text: 'Amount',
          border: [false, true, false, true],
          alignment: 'right',
          fillColor: '#eaf2f5',
          margin: [0, 5, 0, 5],
          textTransform: 'uppercase',
        },
      ]]
    invoiceLineItems.forEach(p => {
      let obj = {};
      obj["loadNumber"] = p.loadNumber;
      obj["crefNo"] = p.loadId.crefNo;
      obj["srefNo"] = p.loadId.srefNo;
      obj["Description"] = p.loadId.Description

      let columnsObj = [
        { text: p.loadNumber, border: [false, false, false, true], fillColor: '#fff', alignment: 'left', margin: [0, 5, 0, 5] },
        { text: p.loadId.crefNo, border: [false, false, false, true], fillColor: '#fff', alignment: 'left', margin: [0, 5, 0, 5] },
        { text: p.loadId.srefNo, border: [false, false, false, true], fillColor: '#fff', alignment: 'left', margin: [0, 5, 0, 5] },
        { text: p.loadId.notes === undefined ? '-' : p.loadId.notes  , border: [false, false, false, true], fillColor: '#fff', alignment: 'left', margin: [0, 5, 0, 5] },
        { text: p.lineItemAmount, border: [false, false, false, true], fillColor: '#f5f5f5', alignment: 'right', margin: [0, 5, 0, 5] }]
      invoiceItemsData.push(columnsObj);
    });

    let subTotal = invoiceLineItems.reduce(function (acc, obj) { return acc + obj.lineItemAmount; }, 0);

    let tax = ((subTotal * 10) / 100);

    let totatAmount = subTotal;

    console.log(invoiceInfo);
    console.log(invoiceItemsData);
    this.generatePDF(invoiceInfo, invoiceItemsData, subTotal, tax, totatAmount);

  }

  generatePDF(invoiceInfo, invoiceItemsData, subTotal, tax, total) {
    console.log(invoiceInfo);
    console.log(JSON.stringify(invoiceInfo));
    console.log(JSON.stringify(invoiceItemsData));
    var dd = {

      content: [
        {
          columns: [
            // {
            //   image:
            //     'data:image/png;base64,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',
            //   width: 150,
            // },
            [
              {
                text: 'Invoice',
                color: '#333333',
                width: '*',
                fontSize: 28,
                bold: true,
                alignment: 'right',
                margin: [0, 0, 0, 15],
              },
              {
                stack: [
                  {
                    columns: [
                      {
                        text: 'Invoice Number',
                        color: '#aaaaab',
                        bold: true,
                        width: '*',
                        fontSize: 12,
                        alignment: 'right',
                      },
                      {
                        text: invoiceInfo.invoiceId,
                        bold: true,
                        color: '#333333',
                        fontSize: 12,
                        alignment: 'right',
                        width: 100,
                      },
                    ],
                  },
                  {
                    columns: [
                      {
                        text: 'Invoice Date',
                        color: '#aaaaab',
                        bold: true,
                        width: '*',
                        fontSize: 12,
                        alignment: 'right',
                      },
                      {
                        text: moment(invoiceInfo.createdAt).format("MM/DD/YYYY"),
                        bold: true,
                        color: '#333333',
                        fontSize: 12,
                        alignment: 'right',
                        width: 100,
                      },
                    ],
                  }
                ],
              },
            ],
          ],
        },
        {
          columns: [
            {
              text: 'From',
              color: '#aaaaab',
              bold: true,
              fontSize: 14,
              alignment: 'left',
              margin: [0, 20, 0, 5],
            },
            {
              text: 'Bill To',
              color: '#aaaaab',
              bold: true,
              fontSize: 14,
              alignment: 'left',
              margin: [0, 20, 0, 5],
            },
          ],
        },
        {
          columns: [
            {
              text: invoiceInfo.companyName,
              bold: true,
              color: '#333333',
              alignment: 'left',
            },
            {
              text: invoiceInfo.customerName,
              bold: true,
              color: '#333333',
              alignment: 'left',
            },
          ],
        },
        {
          columns: [
            {
              text: 'Address',
              color: '#aaaaab',
              bold: true,
              margin: [0, 7, 0, 3],
            },
            {
              text: 'Address',
              color: '#aaaaab',
              bold: true,
              margin: [0, 7, 0, 3],
            },
          ],
        },
        {
          columns: [
            {
              text: invoiceInfo.companyAddress,
              style: 'invoiceBillingAddress',
            },
            {
              text: invoiceInfo.CustomerAddress,
              style: 'invoiceBillingAddress',
            },
          ],
        },
        '\n\n',
        {
          width: '100%',
          alignment: 'center',
          text: 'Invoice Number : ' + invoiceInfo.invoiceId,
          bold: true,
          margin: [0, 10, 0, 10],
          fontSize: 15,
        },
        {
          layout: {
            defaultBorder: false,
            hLineWidth: function (i, node) {
              return 1;
            },
            vLineWidth: function (i, node) {
              return 1;
            },
            hLineColor: function (i, node) {
              if (i === 1 || i === 0) {
                return '#bfdde8';
              }
              return '#eaeaea';
            },
            vLineColor: function (i, node) {
              return '#eaeaea';
            },
            hLineStyle: function (i, node) {
              // if (i === 0 || i === node.table.body.length) {
              return null;
              //}
            },
            // vLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
            paddingLeft: function (i, node) {
              return 10;
            },
            paddingRight: function (i, node) {
              return 10;
            },
            paddingTop: function (i, node) {
              return 2;
            },
            paddingBottom: function (i, node) {
              return 2;
            },
            fillColor: function (rowIndex, node, columnIndex) {
              return '#fff';
            },
          },
          table: {
            headerRows: 1,
            widths: ['40', '*', '*', '*', 80],
            body: invoiceItemsData,
            // [
            //   {
            //     text: 'Load Number',
            //     fillColor: '#eaf2f5',
            //     border: [false, true, false, true],
            //     margin: [0, 5, 0, 5],
            //     textTransform: 'uppercase',
            //   },
            //   {
            //     text: 'Customer Ref',
            //     fillColor: '#eaf2f5',
            //     border: [false, true, false, true],
            //     margin: [0, 5, 0, 5],
            //     textTransform: 'uppercase',
            //   },
            //   {
            //     text: 'Shipper Ref',
            //     fillColor: '#eaf2f5',
            //     border: [false, true, false, true],
            //     margin: [0, 5, 0, 5],
            //     textTransform: 'uppercase',
            //   },
            //   {
            //     text: 'Description',
            //     fillColor: '#eaf2f5',
            //     border: [false, true, false, true],
            //     margin: [0, 5, 0, 5],
            //     textTransform: 'uppercase',
            //   },
            //   {
            //     text: 'Amount',
            //     border: [false, true, false, true],
            //     alignment: 'right',
            //     fillColor: '#eaf2f5',
            //     margin: [0, 5, 0, 5],
            //     textTransform: 'uppercase',
            //   },
            // ],

            // [
            //   {
            //     text: invoiceInfo.loadNumber,
            //     border: [false, false, false, true],
            //     margin: [0, 5, 0, 5],
            //     alignment: 'left',
            //   },
            //   {
            //     text: invoiceInfo.loadId.crefNo,
            //     border: [false, false, false, true],
            //     margin: [0, 5, 0, 5],
            //     alignment: 'left',
            //   },
            //   {
            //     text: 'Item 1',
            //     border: [false, false, false, true],
            //     margin: [0, 5, 0, 5],
            //     alignment: 'left',
            //   },
            //   {
            //     text: invoiceInfo.loadId.srefNo,
            //     border: [false, false, false, true],
            //     margin: [0, 5, 0, 5],
            //     alignment: 'left',
            //   },
            //   {
            //     border: [false, false, false, true],
            //     text: invoiceInfo.invoiceAmount,
            //     fillColor: '#f5f5f5',
            //     alignment: 'right',
            //     margin: [0, 5, 0, 5],
            //   },
            // ],

          },
        },
        '\n',
        '\n\n',
        {
          layout: {
            defaultBorder: false,
            hLineWidth: function (i, node) {
              return 1;
            },
            vLineWidth: function (i, node) {
              return 1;
            },
            hLineColor: function (i, node) {
              return '#eaeaea';
            },
            vLineColor: function (i, node) {
              return '#eaeaea';
            },
            hLineStyle: function (i, node) {
              // if (i === 0 || i === node.table.body.length) {
              return null;
              //}
            },
            // vLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
            paddingLeft: function (i, node) {
              return 10;
            },
            paddingRight: function (i, node) {
              return 10;
            },
            paddingTop: function (i, node) {
              return 3;
            },
            paddingBottom: function (i, node) {
              return 3;
            },
            fillColor: function (rowIndex, node, columnIndex) {
              return '#fff';
            },
          },
          table: {
            headerRows: 1,
            widths: ['*', 80],
            body: [
              // [
              //   {
              //     text: 'Subtotal',
              //     border: [false, true, false, true],
              //     alignment: 'right',
              //     margin: [0, 5, 0, 5],
              //   },
              //   {
              //     border: [false, true, false, true],
              //     text: "$" + subTotal.toFixed(2),
              //     alignment: 'right',
              //     fillColor: '#f5f5f5',
              //     margin: [0, 5, 0, 5],
              //   },
              //   ],
              //   [
              //     {
              //       text: 'Tax',
              //       border: [false, false, false, true],
              //       alignment: 'right',
              //       margin: [0, 5, 0, 5],
              //     },
              //     {
              //       text: '$' + tax.toFixed(2),
              //       border: [false, false, false, true],
              //       fillColor: '#f5f5f5',
              //       alignment: 'right',
              //       margin: [0, 5, 0, 5],
              //     },
              //   ],
              [
                {
                  text: 'Total Amount',
                  bold: true,
                  fontSize: 15,
                  alignment: 'right',
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 5],
                },
                {
                  text: '$ ' + total.toFixed(2),
                  bold: true,
                  fontSize: 15,
                  alignment: 'right',
                  border: [false, false, false, false],
                  fillColor: '#f5f5f5',
                  margin: [0, 5, 0, 5],
                },
              ],
            ],
          },
        },
        '\n\n',
        {
          text: 'Note : This is system generated invoice.',
          style: 'notesTitle',
        },
        '\n\n',
        {
          text: 'Autorized Signature',
          style: 'notesText',
        },
      ],
      styles: {
        notesTitle: {
          fontSize: 10,
          bold: true,
          margin: [0, 50, 0, 3],
        },
        notesText: {
          fontSize: 10,
        },
      },
      defaultStyle: {
        columnGap: 20,
        //font: 'Quicksand',
      },
    };

    var dd2 = {

      content: [
        {
          columns: [
            // {
            //   image:
            //     'data:image/png;base64,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',
            //   width: 150,
            // },
            [
              {
                text: 'Invoice',
                color: '#333333',
                width: '*',
                fontSize: 28,
                bold: true,
                alignment: 'right',
                margin: [0, 0, 0, 15],
              },
              {
                stack: [
                  {
                    columns: [
                      {
                        text: 'Invoice Number',
                        color: '#aaaaab',
                        bold: true,
                        width: '*',
                        fontSize: 12,
                        alignment: 'right',
                      },
                      {
                        text: invoiceInfo.invoiceId,
                        bold: true,
                        color: '#333333',
                        fontSize: 12,
                        alignment: 'right',
                        width: 100,
                      },
                    ],
                  },
                  {
                    columns: [
                      {
                        text: 'Invoice Date',
                        color: '#aaaaab',
                        bold: true,
                        width: '*',
                        fontSize: 12,
                        alignment: 'right',
                      },
                      {
                        text: moment(invoiceInfo.createdAt).format("MM/DD/YYYY"),
                        bold: true,
                        color: '#333333',
                        fontSize: 12,
                        alignment: 'right',
                        width: 100,
                      },
                    ],
                  }
                ],
              },
            ],
          ],
        },
        {
          columns: [
            {
              text: 'From',
              color: '#aaaaab',
              bold: true,
              fontSize: 14,
              alignment: 'left',
              margin: [0, 20, 0, 5],
            },
            {
              text: 'Bill To',
              color: '#aaaaab',
              bold: true,
              fontSize: 14,
              alignment: 'left',
              margin: [0, 20, 0, 5],
            },
          ],
        },
        
        
        
        '\n\n',
        {
          width: '100%',
          alignment: 'center',
          text: 'Invoice Number : ' + invoiceInfo.invoiceId,
          bold: true,
          margin: [0, 10, 0, 10],
          fontSize: 15,
        },
       
        '\n',
        '\n\n',
        
        '\n\n',
        {
          text: 'Note : This is system generated invoice.',
          style: 'notesTitle',
        },
        '\n\n',
        {
          text: 'Autorized Signature',
          style: 'notesText',
        },
      ],
      styles: {
        notesTitle: {
          fontSize: 10,
          bold: true,
          margin: [0, 50, 0, 3],
        },
        notesText: {
          fontSize: 10,
        },
      },
      defaultStyle: {
        columnGap: 20,
        //font: 'Quicksand',
      },
    };

    //pdfMake.createPdf(dd).download();
    pdfMake.createPdf(dd).open();
    //pdfMake.createPdf(dd).print();  

  }



}
